export default __webpack_public_path__ + "images/8d45c68e48577d7ed7cf4a967f45d76b-bluegrass_small.webp";